import type { DropdownOptions } from "../../types";
import { SurveyResponseStatus } from "../../types/documents/SurveyResponse";

export const statusOptions: DropdownOptions = Object.values(
  SurveyResponseStatus
).map((status) => ({
  value: status,
  label: status,
}));
